import React, { useState, useContext, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useStyles } from "./GroupsWAStyles";
import useGroupsWA from "./useGroupsWA";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/Save";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import GetAppIcon from "@material-ui/icons/GetApp"; // Icono Excel
import PersonIcon from "@material-ui/icons/Person"; // Icono Persona
import Chip from "@material-ui/core/Chip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";

import api from "../../services/api";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { SocketContext } from "../../context/Socket/SocketContext";


const GroupsWA = () => {
  const classes = useStyles();
  const {
    connectedWhatsApps,
    exportingGroups,
    extractingGroups,
    extractionProgressRef,
    groupsFromDB,
    groupsFromWhatsApp,
    handleChangePage,
    handleChangeRowsPerPage,
    handleExportParticipants,
    handleExtractParticipants,
    handleListGroups,
    handleSaveAll,
    handleSaveGroup,
    isGroupSaved,
    loading,
    newGroups,
    page,
    paginatedGroups,
    rowsPerPage,
    savedGroups,
    saving,
    selectedWhatsapp,
    setExportingGroups,
    setExtractingGroups,
    setGroupsFromDB,
    setGroupsFromWhatsApp,
    setLoading,
    setNewGroups,
    setPage,
    setRowsPerPage,
    setSavedGroups,
    setSaving,
    setSelectedWhatsapp,
    socketManager,
    whatsApps,
  } = useGroupsWA();

  return (
    <MainContainer>
      <MainHeader>
        <Title>Grupos de WhatsApp</Title>
        <MainHeaderButtonsWrapper>
          <Button
            variant="contained"
            className={classes.buttonPrimary}
            onClick={handleListGroups}
            disabled={loading || !selectedWhatsapp || saving}
            startIcon={loading ? <CircularProgress size={20} /> : <FileCopyIcon />}
            >
              {loading ? 'Listando...' : <><span role="img" aria-label="list">📋</span> Listar Grupos</>}
            </Button>
          
          {newGroups.length > 0 && (
            <Button
              variant="contained"
              className={classes.buttonSuccess}
              onClick={handleSaveAll}
              disabled={loading || saving || !selectedWhatsapp}
              startIcon={saving ? <CircularProgress size={20} /> : <SaveIcon />}
            >
              {saving ? 'Guardando...' : <><span role="img" aria-label="save">💾</span> Guardar Todo ({newGroups.length})</>}
            </Button>
          )}
        </MainHeaderButtonsWrapper>
      </MainHeader>

      <Paper className={classes.mainPaper}>
        {/* ✅ SELECTOR Y ESTADÍSTICAS MEJORADOS */}
        <div className={classes.headerWrapper}>
          <FormControl variant="outlined" className={classes.selectControl}>
            <InputLabel><span role="img" aria-label="whatsapp">💬</span> Conexión WhatsApp</InputLabel>
            <Select
              value={selectedWhatsapp || ''}
              onChange={(e) => setSelectedWhatsapp(e.target.value)}
              label="Conexión WhatsApp"
              disabled={loading || saving}
              renderValue={() => {
                if (!selectedWhatsapp) {
                  return (
                    <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                      <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                      <span>Seleccione una conexión</span>
                    </div>
                  );
                }
                const whatsapp = connectedWhatsApps.find(w => w.id === Number(selectedWhatsapp));
                if (!whatsapp) {
                  return (
                    <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                      <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                      <span>Seleccione una conexión</span>
                    </div>
                  );
                }
                return (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {whatsapp.name || `Conexión ${whatsapp.id}`}
                        </span>
                        <span 
                          style={{ 
                            fontSize: '10px', 
                            padding: '2px 6px', 
                            borderRadius: '10px',
                            backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                            color: 'white',
                            fontWeight: 'bold'
                          }}
                        >
                          {whatsapp.status || 'DISCONNECTED'}
                        </span>
                      </div>
                      <span style={{ fontSize: '12px', color: '#666' }}>
                        {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                         whatsapp.name ? whatsapp.name : 
                         `Conexión ${whatsapp.id}`}
                      </span>
                    </div>
                  </div>
                );
              }}
            >
              {connectedWhatsApps.map((whatsapp) => (
                <MenuItem key={whatsapp.id} value={whatsapp.id}>
                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="WhatsApp">📱</span>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {whatsapp.name || `Conexión ${whatsapp.id}`}
                        </span>
                        <span 
                          style={{ 
                            fontSize: '10px', 
                            padding: '2px 6px', 
                            borderRadius: '10px',
                            backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                            color: 'white',
                            fontWeight: 'bold'
                          }}
                        >
                          {whatsapp.status || 'DISCONNECTED'}
                        </span>
                      </div>
                      <span style={{ fontSize: '12px', color: '#666' }}>
                        {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                         whatsapp.name ? whatsapp.name : 
                         `Conexión ${whatsapp.id}`}
                      </span>
                    </div>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {groupsFromWhatsApp.length > 0 && (
            <>
              <div className={classes.statsCard}>
                <Typography variant="h6"><span role="img" aria-label="stats">📊</span></Typography>
                <Typography variant="body2">
                  <strong>Total:</strong> {groupsFromWhatsApp.length}
                </Typography>
              </div>
              <div className={classes.statsCard}>
                <Typography variant="h6"><span role="img" aria-label="check">✅</span></Typography>
                <Typography variant="body2">
                  <strong>Guardados:</strong> {groupsFromDB.length}
                </Typography>
              </div>
              <div className={classes.statsCard}>
                <Typography variant="h6"><span role="img" aria-label="new">🆕</span></Typography>
                <Typography variant="body2">
                  <strong>Nuevos:</strong> {newGroups.length}
                </Typography>
              </div>
            </>
          )}
        </div>

        {/* ✅ TABLA MEJORADA */}
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader}>Id Grupo</TableCell>
              <TableCell className={classes.tableHeader}>Nombre Grupo</TableCell>
              <TableCell className={classes.tableHeader}>Participantes</TableCell>
              <TableCell className={classes.tableHeader}>Estado</TableCell>
              <TableCell className={classes.tableHeader}>Conexión</TableCell>
              <TableCell className={classes.tableHeader}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRowSkeleton columns={6} />
            ) : groupsFromWhatsApp.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" className={classes.emptyState}>
                  <span className={classes.emptyStateIcon} role="img" aria-label="no-groups">👥</span>
                  <Typography variant="h6" gutterBottom>
                    {selectedWhatsapp ? "Presiona 'Listar Grupos' para comenzar" : "Selecciona una conexión WhatsApp"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {selectedWhatsapp 
                      ? "Obtén la lista de grupos de WhatsApp conectada"
                      : "Elige una conexión WhatsApp disponible para ver sus grupos"
                    }
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              paginatedGroups.map((group) => {
                // ✅ CORRECCIÓN: Normalizar groupId a string para comparación
                const groupIdStr = String(group.groupId || '');
                const isNew = !groupsFromDB.includes(groupIdStr);
                const alreadySaved = isGroupSaved(groupIdStr);
                
                return (
                  <TableRow key={group.groupId} className={classes.tableRow}>
                    <TableCell className={classes.tableCell}>
                      <Typography variant="body2" style={{ fontFamily: 'monospace' }}>
                        {group.groupId}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <strong>{group.name}</strong>
                      {isNew && (
                        <Chip 
                          label="Nuevo" 
                          size="small" 
                          className={`${classes.statusChip} ${classes.newChip}`}
                          style={{ marginLeft: 8 }}
                        />
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Chip 
                        icon={<span role="img" aria-label="members">👥</span>}
                        label={` ${group.participantsCount}`}
                        size="small"
                        className={classes.membersChip}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Chip 
                        label={group.role?.toUpperCase() || 'USER'}
                        className={`${classes.statusChip} ${
                          group.role === 'owner' ? classes.ownerChip :
                          group.role === 'superadmin' ? classes.superadminChip :
                          group.role === 'admin' || group.isAdmin ? classes.adminChip :
                          classes.userChip
                        }`}
                        size="small"
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Chip 
                        label="✅ Activa" 
                        color="primary" 
                        size="small"
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        {/* Botón Excel - Exportar participantes */}
                        {exportingGroups.has(group.groupId) || loading ? (
                          <Tooltip title="Exportar participantes a Excel">
                            <span>
                              <IconButton
                                size="small"
                                disabled
                                color="primary"
                                className={classes.actionButton}
                              >
                                <CircularProgress size={16} />
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Exportar participantes a Excel">
                            <IconButton
                              size="small"
                              onClick={() => handleExportParticipants(group)}
                              color="primary"
                              className={classes.actionButton}
                            >
                              <GetAppIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        {/* Botón Persona - Extraer y guardar participantes */}
                        {group.hasParticipantsInDB ? (
                          <Tooltip title="Participantes ya guardados en BD">
                            <span>
                              <IconButton
                                size="small"
                                disabled
                              >
                                <CheckCircleIcon style={{ color: '#2e7d32' }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : extractingGroups.has(group.groupId) || loading ? (
                          <Tooltip title="Extraer y guardar participantes en BD">
                            <span>
                              <IconButton
                                size="small"
                                disabled
                                color="secondary"
                                className={classes.actionButton}
                              >
                                <CircularProgress size={16} />
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Extraer y guardar participantes en BD">
                            <IconButton
                              size="small"
                              onClick={() => handleExtractParticipants(group)}
                              color="secondary"
                              className={classes.actionButton}
                            >
                              <PersonIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        {/* Botón Guardar grupo (existente) */}
                        {isNew && !alreadySaved ? (
                          saving ? (
                            <Tooltip title="Guardar este grupo">
                              <span>
                                <IconButton
                                  size="small"
                                  disabled
                                  color="primary"
                                  className={classes.actionButton}
                                >
                                  <SaveIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Guardar este grupo">
                              <IconButton
                                size="small"
                                onClick={() => handleSaveGroup(group)}
                                color="primary"
                                className={classes.actionButton}
                              >
                                <SaveIcon />
                              </IconButton>
                            </Tooltip>
                          )
                        ) : (
                          <Tooltip title="Ya guardado en base de datos">
                            <span>
                              <IconButton
                                size="small"
                                disabled
                              >
                                <CheckCircleIcon style={{ color: '#2e7d32' }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
        
        {/* ✅ PAGINACIÓN: Solo aparece cuando hay resultados */}
        {!loading && groupsFromWhatsApp.length > 0 && (
          <TablePagination
            component="div"
            count={groupsFromWhatsApp.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 20, 50, 100]}
            labelRowsPerPage="Registros por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            style={{
              backgroundColor: 'transparent',
              color: 'inherit',
            }}
          />
        )}
      </Paper>
    </MainContainer>
  );
};

export default GroupsWA;

